module.exports = __webpack_public_path__ + "img/ks_top.87d1ad89.png";